import { render } from "./PriceList.vue?vue&type=template&id=3e302ef7&scoped=true&ts=true"
import script from "./PriceList.vue?vue&type=script&lang=ts"
export * from "./PriceList.vue?vue&type=script&lang=ts"

import "./PriceList.vue?vue&type=style&index=0&id=3e302ef7&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e302ef7"]])

export default __exports__